import styled, { css } from 'styled-components';

import Heading from 'components/_core/Heading';
import Text from 'components/_core/Text';

export const Root = styled.div`
  border-left: solid 1px ${({ theme }) => theme.colors.grey(3)};
  display: flex;
  flex: 1;
  flex-direction: column;
  padding: ${({ theme }) => css`
    ${theme.spacings.abs40}px
    ${theme.spacings.abs24}px
    ${theme.spacings.abs24}px
  `};
`;

export const Title = styled(Heading)`
  display: block;
  margin-bottom: ${({ theme }) => theme.spacings.abs16}px;
`;

export const SubTitle = styled(Text)`
  display: block;
  margin-bottom: ${({ theme }) => theme.spacings.abs32}px;
`;

export const LoaderWrapper = styled.div`
  height: 80px;
`;
